// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__oNmkT","notes":"Notes_notes__1GZA1"};